import { render, staticRenderFns } from "./CandFiltersSidebar.vue?vue&type=template&id=50ae7355&"
import script from "./CandFiltersSidebar.vue?vue&type=script&lang=js&"
export * from "./CandFiltersSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports